import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { H2 } from '../typography';
import Gallery from './Gallery';

const Header = styled(H2)`
  color: ${props => props.theme.color.textDark} !important;
`;

const StepWrapper = styled.div`
  max-width: 961px;
  margin: 0 auto 20px;
  border-bottom: 2px solid ${props => props.theme.color.borderSecondary};
  padding: 40px 12px 52px 12px;
`;

const TitleSpan = styled.span`
  font-weight: ${props => props.theme.fontWeight.regular};
  margin-left: 20px;
`;

class Steps extends Component {
  static propTypes = {
    number: PropTypes.number,
    step: PropTypes.object
  };

  render() {
    const { number, step } = this.props;
    const { images, lines, stepid, title, video } = step;
    return (
      <StepWrapper>
        <Header>
          Step {number}:<TitleSpan> {title}</TitleSpan>
        </Header>
        <Gallery images={images} lines={lines} stepid={stepid} video={video} />
      </StepWrapper>
    );
  }
}

export default Steps;



// WEBPACK FOOTER //
// ./src/components/Steps/index.js